// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import AccountForm from '../../_common/AccountForm';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Cart from '../../_common/Cart';
import Button from '../../_common/form/Button';
import Heading from '../../_common/form/Heading';
import Input from '../../_common/form/Input';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Modal from '../../_common/Modal';
import UpdatePassword from '../../_common/UpdatePassword';
import Page from '../pageLayout/Page';
import UserHistory from '../UserHistory';
import { HamQuest } from '../../../App';
import { DeleteButton } from '../../_pwa/pages/Account';

const Row = styled.div`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    min-width: 40%;
    flex-grow: 1;
`

const UserManagement = () => {
    const {
        state: {
            active_user,
        },
        logOut
    } = useGlobalState();

    const [values, setValues] = useState({
        firstName: active_user.account.firstName,
        lastName: active_user.account.lastName,
        email: active_user.account.email,
        cellPhoneNumber: active_user.account.cellPhoneNumber,
        loyaltyPoints: '0'
    })

    useEffect(() => {
        HamQuest.get(QuestRoute.user.loyaltyPoints)
            .then((res) => setValues({
                ...values,
                loyaltyPoints: res.current_points
            }))
    }, [])

    const handlePWUpdate = () => {
        Modal.Show({
            title: 'Update Password',
            icon: 'lock',
            body: <UpdatePassword />
        })
    }

    const handleDelete = () => {
        Modal.Confirmation({
            title: 'Hold On!',
            type: 'warning',
            body: `Are you sure you want to delete your account?`,
            hideClose: true,
            closeAfter: true,
        })
            .then(res => {
                if (!res) return;
                Modal.Confirmation({
                    title: 'LAST CHANCE!',
                    type: 'error',
                    body: `Are you sure you want to delete your account? This can not be undone! You will lose access to any and all unredeemed items.`,
                    hideClose: true,
                    closeAfter: true,
                })
                    .then(res => {
                        if (!res) return;
                        HamQuest.delete(QuestRoute.user.delete)
                            .then(() => {
                                Cart.Empty();
                                logOut();
                            })
                    })
            })
    }

    const account = {
        firstName: active_user.account.firstName,
        lastName: active_user.account.lastName,
        email: active_user.account.email,
        confirmEmail: active_user.account.email,
        birthdayMonth: active_user.account.birthdayMonth,
        birthdayDay: active_user.account.birthdayDay,
        cellPhoneNumber: active_user.account.cellPhoneNumber,
        zipPostalCode: active_user.account.zipPostalCode,
    }

    return (
        <Page>
            <Row>
                <Col>
                    <Heading>Account Info</Heading>
                    <AccountForm
                        inputs={account}
                        submitButton='Update'
                        submittingButton='Updating'
                        displayform
                    />
                    <Button onClick={handlePWUpdate}>Update Password</Button>

                    <DeleteButton
                        onClick={handleDelete}
                    >Delete Account</DeleteButton>
                </Col>
                <Col>
                    {
                        active_user.washClub ?
                            <>
                                <Heading>Wash Club</Heading>
                                <Input
                                    standalone
                                    label='Wash Club'
                                    value={active_user.washClub.name}
                                    disabled
                                />
                                <Input
                                    standalone
                                    label='Current Uses'
                                    value={active_user.washClub.useCountDisplay}
                                    disabled
                                />
                                <Input
                                    standalone
                                    label='License Plate'
                                    value={active_user.washClub.appUserVehicle?.license}
                                    disabled
                                />
                                <Input
                                    standalone
                                    label='Next Billing Date'
                                    value={new Date(active_user.washClub.nextBillingDate).toLocaleDateString()}
                                    disabled
                                />
                            </> : null
                    }
                    
                    <Heading>Payment Info</Heading>
                    {
                        // HERE 
                        // active_user.payment.onFile ?
                        active_user.payment.onFile ?
                            <>
                                <Input
                                    standalone
                                    label='Card Type'
                                    value={active_user.payment.cardType}
                                    disabled
                                />
                                <Input
                                    standalone
                                    label='Card Number'
                                    value={'XXXX-XXXX-XXXX-' + active_user.payment.maskedCardNumber.match(/\d+/g)[0]}
                                    disabled
                                />
                                <Input
                                    standalone
                                    label='Expiration'
                                    value={`${active_user.payment.expirationMonth} / ${active_user.payment.expirationYear}`}
                                    disabled
                                />
                            </> : <div>None on file</div>
                    }
                    <Button onClick={() => Cart.AddCardToAccount()}>{active_user.payment ? 'Update Card' : 'Add Card'}</Button>
                </Col>

            </Row>
            <Col>
                <UserHistory />
            </Col>
        </Page>
    );
}

export default UserManagement;
